import {
  AccessTime,
  Add,
  ArrowRight,
  CheckCircle,
  Close,
  ContentCopy,
  CopyAll,
  Edit,
  EditNote,
  ErrorOutline,
  HeadsetMic,
  Info,
  InfoOutlined,
  KeyboardArrowDown,
  KeyboardArrowRight,
  PhoneInTalkOutlined,
  RunCircleRounded,
} from "@mui/icons-material";
import {
  TextField,
  Select,
  MenuItem,
  Checkbox,
  Button,
  Divider,
  CircularProgress,
  InputBase,
  Alert,
  FormControl,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { json, useNavigate, useParams } from "react-router-dom";
import DeleteRouteModal from "../modals/DeleteRouteModal";
import planData from "../plans.json";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { useWindowSize } from "react-use";
import Confetti from "react-confetti";

import { jwtDecode } from "jwt-decode";
import AllSetUpModal from "../modals/AllSetUpModal";
import ConfirmPageReload from "../modals/ConfirmPageReload";
import { formatPhoneNumber } from "../utils/formatnumber";
import ChangeOrgModal from "../modals/ChangeOrgModal";
import ChangeOrgModalNew from "../modals/ChangeOrgModalNew";
import posthog from "posthog-js";
import decryptApi from "../utils/decryptApi";
import ConfigureSlotModal from "../modals/ConfigureSlotModal";
import AudioPlayerForRouting from "../reusables/AudioPlayerForRouting";
import ConfigureCallActionModal from "../modals/ConfigureCallActionModal";
import ConfigureCallActionForBusinessModal from "../modals/ConfigureCallActionForBusinessHours";
import ConfigureCallActionForAfterModal from "../modals/ConfigureCallActionForAfterHours";
import ConfigureNotificationForAfterHours from "../modals/ConfigureNotificationForAfterHours";
import ConfigureNotificationForBusinessHours from "../modals/ConfigureNotificationForBusinessHours";
import ConfigureNotificationModal from "../modals/ConfigureNotificationMainModal";
import IvrMenu from "../RouteParts/IvrMenu";
import { Settings2 } from "lucide-react";
import { RouteConfigModalsProvider } from "../contexts/RouteConfigModalsContext";
import { getVoiceUrlOldNumberUpdatedMessage } from "../utils/voiceUrlSyncNotice";
const CallRoute = ({ navigate }) => {
  const { route_id } = useParams();
  const [loader, setLoader] = useState(true);
  const [error_msg, setErrormsg] = useState(null);

  const [planDetails, setPlanDetails] = useState(null);
  const check_subscription = async () => {
    try {
      setLoader(true);
      let sub = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "stripe/check-subscription",
        {
          organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
          customer_id: JSON.parse(localStorage.getItem("organization"))
            .subscription_details.M.stripe_cust_id.S,
        }
      );

      setPlanDetails(planData[sub.data?.planDetails[0].plan_id]);
      return;
    } catch (error) {
      // Log for production diagnostics when subscription check fails
      console.error("CallRoute: check subscription failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  };
  const [routes, setRoutes] = useState([]);

  const getRoutes = async () => {
    try {
      let routes = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "route/get-routes",
        { org_id: JSON.parse(localStorage.getItem("organization")).orgId.S }
      );

      setRoutes(routes.data.routes);
      setRoute({
        ...route,
        route_name: `Route ${
          routes.data.routes ? routes.data.routes.length + 1 : 1
        }`,
      });
    } catch (error) {
      // Log for production diagnostics when get routes fails
      console.error("CallRoute: get routes failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  useEffect(() => {
    getRoutes();
    check_subscription();
  }, []);

  const [route, setRoute] = useState({
    route_name: `loading...`,
    configured_phone: JSON.parse(localStorage.getItem("organization"))
      .twilio_integration.M.primary_phone.S,
    organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
    early_time: "12:00 AM",
    late_time: "11:59 PM",
    primaryAction: "forward",
    recording_id: null,
    primary_number: null,
    off_hours_number: null,
    primary_channel: null,
    offHoursAction: "forward",
    off_hours_recording: null,
    off_hours_number: null,
    off_hours_channel: null,
    active_friday: false,
    active_monday: false,
    active_saturday: false,
    active_sunday: false,
    active_thursday: false,
    active_tuesday: false,
    active_wednesday: false,
  });

  const [change_org, setChangeOrg] = useState(false);

  const [calls, setCalls] = useState(null);
  const [incomming_phonenumbers, setIncommingPhonenumbers] = useState(null);
  const [editName, setEditName] = useState(false);
  const [notification, setNotification] = useState({
    notification: "none",

    notification_detail: null,
  });

  const [off_hours_notification, setOffHoursNotification] = useState({
    notification: "none",

    notification_detail: null,
  });

  useEffect(() => {}, [notification.notification_detail]);

  useEffect(() => {}, [off_hours_notification.notification_detail !== null]);

  const getRoute = async () => {
    try {
      let route = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "route/get-route",
        { route_id, org_id: JSON.parse(localStorage.getItem("organization")).orgId.S }
      );

      getIncomingPhoneNumbers();
      setLoader(false);

      // let calls = await axios.post(
      //   process.env.REACT_APP_BACKEND_URL + "call/get-calls-by-route",
      //   { route_id, organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S }
      // );

      // const now = Date.now();
      // const thirtyDaysAgo = now - 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

      // let rc = calls.data.calls.filter(call => {
      //   const timestamp = parseInt(call.startTime.N, 10); // Convert N field to a number
      //   return timestamp >= thirtyDaysAgo && timestamp <= now;
      // });

      // console.log('recent_calls', rc)

      // setCalls(rc);

      let r = route?.data.route;

      setRoute({
        route_id: r.routeId,
        route_name: r.name,
        primaryNotification: r.PrimaryNotification,
        offHoursNotification: r.OffHoursNotification,
        configured_phone: r.configured_phone,
        organization_id: r.org_id,
        early_time: r.earlyTime,
        late_time: r.lateTime,
        primaryAction: r.primaryAction ?? r.primary_action,
        recording_id: r.primaryRecording,
        primary_number: r.primaryNumber,
        off_hours_number: r.offHoursNumber,
        primary_channel: r.primaryChannel,
        offHoursAction: r.offHoursAction ?? r.offhours_action,
        off_hours_recording: r.offHoursRecording,
        off_hours_number: r.offHoursNumber,
        off_hours_channel: r.offHoursChannel,
        active_friday: r.calendar.fri.BOOL,
        active_monday: r.calendar.mon.BOOL,
        active_saturday: r.calendar.sat.BOOL,
        active_sunday: r.calendar.sun.BOOL,
        active_thursday: r.calendar.thur.BOOL,
        active_tuesday: r.calendar.tue.BOOL,
        active_wednesday: r.calendar.wed.BOOL,
      });

      let channels = JSON.parse(localStorage.getItem("organization")).channels
        ?.L;

      setNotification({
        notification:
          channels.filter((ch) => ch.M.ch_id.S === r.primaryChannel)[0]?.M.type
            .S || "none",
        notification_detail:
          channels.filter((ch) => ch.M.ch_id.S === r.primaryChannel)[0]?.M.value
            .S || "",
      });

      setOffHoursNotification({
        notification:
          channels.filter((ch) => ch.M.ch_id.S === r.offHoursChannel)[0]?.M.type
            .S || "none",
        notification_detail:
          channels.filter((ch) => ch.M.ch_id.S === r.offHoursChannel)[0]?.M
            .value.S || "",
      });
    } catch (error) {
      // Log for production diagnostics when get route fails
      console.error("CallRoute: get route failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  async function getIncomingPhoneNumbers(apiSecret) {
    setLoader(true);
    setErrormsg(null);
    const org = JSON.parse(localStorage.getItem("organization"));
    await axios
      .post(
        process.env.REACT_APP_BACKEND_URL + "twilio/get-incoming-phone-numbers",
        { organization_id: org.orgId.S }
      )
      .then((res) => {
        if (res.data.length < 1) {
          setErrormsg(
            "please add an incoming phone number in your twilio account"
          );
          setLoader(false);
        } else {
          setIncommingPhonenumbers(res.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        // Log for production diagnostics when get incoming phone numbers fails
        console.error("CallRoute: get incoming phone numbers failed", err.response?.data || err.message || err);
        if (err.response && err.response.data) {
          setErrormsg(err.response.data.message);
        }
        setLoader(false);
      });
  }
  async function updateRoute() {
    setLoader(true);
    let check = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
      {
        userId: JSON.parse(localStorage.getItem("user")).userId.S,
      }
    );

    if (check.status === 200) {
      const user___ = check.data.user;

      if (
        user___.relatedOrgs.L?.find(
          (e) =>
            e?.M.org_id?.S ===
            JSON.parse(localStorage.getItem("organization")).orgId.S
        )
      ) {
        try {
          let route_data = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "route/update-route",
            { ...route, org_id: JSON.parse(localStorage.getItem("organization")).orgId.S }
          );

          setLoader(false);
          getRoute();
          const baseSuccess = "Route Settings Successfully Updated";
          const voiceFollowUp = getVoiceUrlOldNumberUpdatedMessage(
            route_data.data?.voiceUrlSync,
            { newPhoneNumber: route.configured_phone }
          );
          setSuccessMsg(
            voiceFollowUp ? `${baseSuccess}\n\n${voiceFollowUp}` : baseSuccess
          );
          window.scrollTo({ top: 0, behavior: "smooth" });
          const dismissMs = voiceFollowUp ? 14000 : 4000;
          setTimeout(() => {
            setSuccessMsg(null);
          }, dismissMs);
        } catch (error) {
          // Log for production diagnostics when update route fails
          console.error("CallRoute: update route failed", error.response?.data || error.message || error);
          if (error.response && error.response.data) {
            setErrormsg(error.response.data.message);
          }
          setLoader(false);
        }
      } else {
        window.location.reload();
      }
    }
  }

  async function deleteRoute() {
    setLoader(true);
    setOpenDeleteRouteModal(false);

    let check = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
      {
        userId: JSON.parse(localStorage.getItem("user")).userId.S,
      }
    );

    if (check.status === 200) {
      const user___ = check.data.user;

      if (
        user___.relatedOrgs.L?.find(
          (e) =>
            e?.M.org_id?.S ===
            JSON.parse(localStorage.getItem("organization")).orgId.S
        )
      ) {
        try {
          let route_data = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "route/delete-route",
            { route_id, org_id: JSON.parse(localStorage.getItem("organization")).orgId.S }
          );

          let organization = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "delete-route",
            {
              organization_id: JSON.parse(localStorage.getItem("organization"))
                .orgId.S,
              route_id,
            }
          );

          localStorage.setItem(
            "organization",
            JSON.stringify(organization.data.organization)
          );

          let t = JSON.parse(localStorage.getItem("organization"))
            .twilio_integration.M;

          if (t?.auto_configuration?.BOOL) {
            let update_voice = await axios.post(
              process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
              {
                org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
                phone_number: route.configured_phone,
                webhook_url: `https://incoming.twilanswer.com/default`,
              }
            );
          }
          setLoader(false);
          setSuccessMsg(
            "Route Successfully Deleted. Remember to Update Twilio Settings. Redirecting you to your call routes"
          );
          setTimeout(() => {
            setSuccessMsg(null);
            navigate("/dashboard/call-routings/");
          }, 4000);
        } catch (error) {
          // Log for production diagnostics when delete route fails
          console.error("CallRoute: delete route failed", error.response?.data || error.message || error);
          if (error.response && error.response.data) {
            setErrormsg(error.response.data.message);
          }
          setLoader(false);
        }
      } else {
        window.location.reload();
      }
    }
  }

  async function createRoute() {
    setLoader(true);

    let check = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
      {
        userId: JSON.parse(localStorage.getItem("user")).userId.S,
      }
    );

    if (check.status === 200) {
      const user___ = check.data.user;

      if (
        user___.relatedOrgs.L?.find(
          (e) =>
            e?.M.org_id?.S ===
            JSON.parse(localStorage.getItem("organization")).orgId.S
        )
      ) {
        try {
          let route_data = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "route/create-route",
            route
          );

          let organization = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "add-route",
            {
              organization_id: JSON.parse(localStorage.getItem("organization"))
                .orgId.S,
              route_id: route_data.data.route.routeId.S,
            }
          );

          localStorage.setItem(
            "organization",
            JSON.stringify(organization.data.organization)
          );

          let t = JSON.parse(localStorage.getItem("organization"))
            .twilio_integration.M;

          if (t?.auto_configuration?.BOOL) {
            let update_voice = await axios.post(
              process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
              {
                org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
                phone_number: route.configured_phone,
                webhook_url: `https://incoming.twilanswer.com/${route_data.data.route.routeId.S}`,
              }
            );
          }
          setLoader(false);

          setSuccessMsg("Route saved successfully. Redirecting you now.");
          window.scrollTo({ top: 0, behavior: "smooth" });
          //post hog track event for create route
          posthog.capture("Created a route", {
            email: JSON.parse(localStorage.getItem("user")).email.S,
            userId: JSON.parse(localStorage.getItem("user")).userId.S,
          });

          setTimeout(() => {
            setSuccessMsg(null);
            navigate(
              "/dashboard/call-route/" + route_data.data.route.routeId.S
            );
          }, 2000);
        } catch (error) {
          // Log for production diagnostics when create route fails
          console.error("CallRoute: create route failed", error.response?.data || error.message || error);
          if (error.response && error.response.data) {
            setErrormsg(error.response.data.message);
          }
          setLoader(false);
        }
      } else {
        window.location.reload();
      }
    }
  }

  useEffect(() => {
    if (route_id) {
      // getRoute();
    } else {
      getIncomingPhoneNumbers();
      setLoader(false);
    }
  }, []);

  useEffect(() => {
    // console.log(route.organization_id)
    // if(route.organization_id !== JSON.parse(localStorage.getItem("organization")).orgId.S){
    //   setChangeOrg(true)
    // }

    if (route_id && routes?.length >= 1) {
      if (routes.find((e) => e.routeId.S === route_id)) {
        getRoute();
        setChangeOrg(false);
      } else {
        setChangeOrg(true);
      }
    } else if (!route_id) {
      setChangeOrg(false);
    } else {
      setChangeOrg(true);
    }
  }, [routes]);

  const [copied, setCopied] = useState(false);
  async function copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      // Log when clipboard API fails
      console.error("Failed to copy text:", err);
    }
  }
  const [openDeleteRouteModal, setOpenDeleteRouteModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);
  const handleTimeChange = (e) => {
    const value = e.target.value;
    let [hours, minutes] = value.split(":");
    hours = parseInt(hours);
    let period = "AM";
    if (hours >= 12) {
      period = "PM";
      if (hours > 12) hours -= 12;
    }
    if (hours === 0) hours = 12;
    const formattedTime = `${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${period}`;
    alert(formattedTime);
    setRoute({ ...route, early_time: formattedTime });
  };

  function convertTo24Hour(time) {
    let [hours, minutes] = time.split(/[: ]/);
    const period = time.slice(-2);

    hours = parseInt(hours);
    if (period === "AM" && hours === 12) hours = 0;
    if (period === "PM" && hours < 12) hours += 12;

    const formattedHours = String(hours).padStart(2, "0");
    return `${formattedHours}:${minutes}`;
  }

  function convertTo12Hour(time) {
    let [hours, minutes] = time.split(":");
    hours = parseInt(hours);
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    // Convert "0" or "00" to "12"
    const formattedTime = `${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${period}`;
    return formattedTime;
  }
  const { width, height } = useWindowSize();

  const [confetti, setConfetti] = useState(
    localStorage.getItem("show_confetti")
  );
  let confettiPieces = 1000; // Initial number of confetti pieces

  // useEffect(()=>{
  //   setTimeout(() => {
  //     localStorage.removeItem('show_confetti')
  //     setConfetti(false)
  //   }, 5000);
  // })
  useEffect(() => {
    if (confetti) {
      const interval = setInterval(() => {
        if (confettiPieces > 0) {
          confettiPieces -= 10; // Reduce by 10 pieces
        }
      }, 1000); // Interval runs every 100 milliseconds

      setTimeout(() => {
        clearInterval(interval); // Stop the interval after 5 seconds
        setConfetti(false);
        localStorage.removeItem("show_confetti");
      }, 10000);
    }
  }, [confetti]);
  const [openAllSetUpModal, setOpenAllSetupModal] = useState(false);
  const cameFromRegister = localStorage.getItem("cameFromRegister") === "true";

  useEffect(() => {
    if (cameFromRegister) {
      setOpenAllSetupModal(true);
      localStorage.removeItem("cameFromRegister");
    }
  }, [cameFromRegister]);

  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [page, setPage] = useState(null);

  const handleNavigation = (to) => {
    window.location.assign(to);
  };

  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [orgs, setOrgs] = useState();

  useEffect(() => {
    const loadOrgs = async () => {
      const { getAllOrgs } = await import('../../utils/getAllOrgs');
      try {
        await getAllOrgs(setOrgs, setLoader);
      } catch (error) {
        // Log for production diagnostics when org list fails to load
        console.error('[CallRoute] Error loading organizations:', error);
      }
    };
    loadOrgs();
    const handleBeforeUnload = (event) => {
      // Prevent the default browser prompt
      event.preventDefault();
      // Modern browsers may still show a generic warning; this avoids it
      event.returnValue = "";
    };

    // Add event listener for beforeunload
    window.addEventListener("beforeunload", handleBeforeUnload);
    // Cleanup the event listener
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const changeOrganization = async (org_id) => {
    try {
      const { fetchAndSetOrganization } = await import("../../utils/organizationService");
      await fetchAndSetOrganization(org_id);
      window.location.reload();
    } catch (error) {
      // Log for production diagnostics when change organization fails
      console.error("CallRoute: change organization failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  const [enableBusinessHours, setEnableBusinessHours] = useState(false);

  const handleTimeChange2 = (day, type, value) => {
    setRoute({
      ...route,
      [`${day}_${type}_time`]: convertTo12Hour(value),
    });
  };

  const handleToggle = (day, checked) => {
    setRoute({
      ...route,
      [`active_${day}`]: checked,
    });
  };

  const [openConfigureSlotModal, setOpenConfigureSlotModal] = useState(false);
  const [
    openConfigureNotificationMainModal,
    setOpenConfigureNotificationMainModal,
  ] = useState(false);
  const [openConfigureCallActionModal, setOpenConfigureCallActionModal] =
    useState(false);
  const [
    openConfigureCallActionForBusinessHoursModal,
    setOpenConfigureCallActionForBusinessHoursModal,
  ] = useState(false);
  const [
    openConfigureCallActionForAfterHoursModal,
    setOpenConfigureCallActionForAfterHoursModal,
  ] = useState(false);

  const [
    openConfigureNotificationForBusinessHoursModal,
    setOpenConfigureNotificationForBusinessHoursModal,
  ] = useState(false);
  const [
    openConfigureNotificationForAfterHoursModal,
    setOpenConfigureNotificationForAfterHoursModal,
  ] = useState(false);
  const [slot, setSlot] = useState();
  const [notificationMain, setNotificationMain] = useState();
  const [callAction, setCallAction] = useState();
  const [businessHourCallActionChoice, setBusinessHourCallActionChoice] =
    useState();
  const [AfterHourCallActionChoice, setAfterHourCallActionChoice] = useState();

  const [businessHourNotificationChoice, setBusinessHourNotificationChoice] =
    useState();
  const [AfterHourNotificationChoice, setAfterHourNotificationChoice] =
    useState();

  const [selectedRecordingTemplate, setSelectedRecordingTemplate] = useState();

  const [options_, setOptions] = useState([
    {
      id: "press_1",
      name: "Press 1",
      call_action: null,
      notification: null,
    },
  ]);

  const handleCloseCallActionOptions = (option) => {
    setOptions((prev) => prev.filter((e) => e.id !== option.id));
  };

  const convertRouteToCalendar = (route) => {
    const dayKeyMap = {
      monday: "mon",
      tuesday: "tue",
      wednesday: "wed",
      thursday: "thur",
      friday: "fri",
      saturday: "sat",
      sunday: "sun",
    };

    const calendar = {};

    Object.entries(dayKeyMap).forEach(([longKey, shortKey]) => {
      const enabled = route[`active_${longKey}`] || false;
      const startTime = route[`${longKey}_early_time`] || "9:00 AM";
      const endTime = route[`${longKey}_late_time`] || "5:00 PM";

      calendar[shortKey] = {
        enabled,
        startTime: startTime,
        endTime: endTime,
      };
    });

    return calendar;
  };

  const [newRoute, setNewRoute] = useState({
    org_id: route.organization_id,
    name: route.route_name,
    calendar: convertRouteToCalendar(route),
    primaryAction: slot,
  });

  const createNewRoute = () => {
    const newRoute = {
      // routeId: "rte_enhanced_calendar_test_789",
      org_id: route.organization_id,
      name: route.route_name,
      calendar: convertRouteToCalendar(route),
      primaryAction: slot,
      ivr_menu: {
        menu_recording: selectedRecordingTemplate,
        hangup_recording: selectedRecordingTemplate,
        options: {
          1: {},
        },
      },
    };
  };

  return (
    <>
      {/* <ChangeOrgModalNew open={change_org} setOpen={setChangeOrg}  /> */}
      {confetti && (
        <Confetti
          width={width - 30}
          height={height}
          numberOfPieces={confettiPieces}
          gravity={0.1} // Controls how fast confetti falls
          recycle={false}
        />
      )}

      <ConfirmPageReload
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        page={page}
      />
      <AllSetUpModal open={openAllSetUpModal} setOpen={setOpenAllSetupModal} />
      <RouteConfigModalsProvider planDetails={planDetails}>
      <div className="pt-7 px-4">
        <DeleteRouteModal
          open={openDeleteRouteModal}
          setOpen={setOpenDeleteRouteModal}
          num={route.configured_phone}
          deleteRoute={deleteRoute}
        />
        {error_msg && (
          <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
            <ErrorOutline sx={{ fontSize: "" }} /> {error_msg}
          </div>
        )}

        {successMsg && (
          <Alert color={"success"} sx={{ my: 2 }}>
            <div className="text-[14px] whitespace-pre-line">{successMsg}</div>
          </Alert>
        )}

        {/* {loader && (
        <div className="flex justify-center">
          <CircularProgress size={"3rem"} sx={{ color: "blue" }} />
        </div>
      )} */}

        {!change_org ? (
          <div>
            <div className="lg:flex items-center mb-4 lg:space-x-8 lg:space-y-0 space-y-3 relative">
              <div className="flex items-center lg:space-x-8 space-x-0 justify-between">
                {loader && (
                  <div className="flex justify-center">
                    <CircularProgress
                      size={"1.0rem"}
                      sx={{ color: "#605BFF", animationDuration: "0.7s" }}
                    />
                  </div>
                )}
                <div className="text-[17px] font-semibold ">
                  {editName ? (
                    <InputBase
                      value={route?.route_name}
                      onChange={(e) => {
                        setRoute({ ...route, route_name: e.target.value });
                      }}
                      sx={{
                        bgcolor: "white",
                        width: "100%",
                        px: 2,
                        py: "2px",
                        fontSize: "14px",
                      }}
                    />
                  ) : (
                    <>{route?.route_name}</>
                  )}
                </div>
                <div
                  onClick={() => {
                    createNewRoute();
                  }}
                >
                  {" "}
                  save{" "}
                </div>
                <div className="cursor-pointer">
                  {editName ? (
                    <div
                      className="cursor-pointer hover:underline hover:text-purple-500 text-[14px]"
                      onClick={() => {
                        setEditName(false);
                      }}
                    >
                      Save{" "}
                    </div>
                  ) : (
                    <EditNote
                      sx={{ color: "gray", width: "25px" }}
                      onClick={() => {
                        setEditName(true);
                      }}
                    />
                  )}
                </div>
              </div>
              <div
                className="bg-[#FAFAFB]  py-2 text-[12px] px-4 text-center font-semibold rounded-[15px] break-words"
                hidden={!route_id && true}
              >
                https://incoming.twilanswer.com/{route_id}{" "}
                {copied ? (
                  <CheckCircle
                    className="cursor-pointer"
                    onClick={() => {
                      copyToClipboard(
                        `https://incoming.twilanswer.com/${route_id}`
                      );
                    }}
                    sx={{
                      color: "gray",
                      width: "20px",
                      position: "relative",
                      bottom: 2,
                    }}
                  />
                ) : (
                  <ContentCopy
                    className="cursor-pointer"
                    onClick={() => {
                      copyToClipboard(
                        `https://incoming.twilanswer.com/${route_id}`
                      );
                    }}
                    sx={{
                      color: "gray",
                      width: "20px",
                      position: "relative",
                      bottom: 2,
                    }}
                  />
                )}
              </div>

              {/* {route_id && calls ? (
                <div
                  onClick={() => {
                    handleNavigation('/dashboard')
                  }}
                  className=" cursor-pointer bg-[rgba(96,91,255,0.1)] rounded-[15px] w-[190px] justify-center py-2 text-[#605BFF] flex items-center text-[12px] font-semibold">
                  <img src="/icons/phone_purple.png" className="w-[20px] mr-2" />{" "}
                  {calls?.length} Calls Last 30 Days
                </div>
              ): (
                <div className="flex justify-center">
                <CircularProgress size={"1rem"} sx={{ color: "rgb(96,91,255)",animationDuration:'0.7s' }} />
              </div>
              )} */}

              <div className=" lg:absolute  right-0" hidden={!route_id && true}>
                <Button
                  sx={{
                    textTransform: "none",
                    bgcolor: "#D11A2A",
                    color: "white",
                    py: "5px",
                    px: "20px",
                    borderRadius: "12px",
                    fontSize: { lg: "14px", xs: "12px" },
                  }}
                  disabled={loader}
                  onClick={() => {
                    setOpenDeleteRouteModal(true);
                  }}
                >
                  Delete Route
                </Button>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center w-full space-y-5">
              <div className="border border-gray-200 rounded-xl p-6 bg-white w-[740px]  ">
                <div className="flex items-start space-x-3">
                  <PhoneInTalkOutlined className="text-blue-500 mt-1" />
                  <div>
                    <h2 className="text-lg font-semibold text-gray-900">
                      Incoming Call
                    </h2>
                    <p className="text-sm text-gray-600">
                      Configure which phone number receives calls
                    </p>
                  </div>
                </div>

                <div className="mt-6">
                  <label className="block text-sm font-medium text-gray-800 mb-1">
                    Phone Number
                  </label>
                  <FormControl fullWidth size="small">
                    <Select
                      displayEmpty
                      value={route?.configured_phone}
                      onChange={(e) => {
                        setRoute({
                          ...route,
                          configured_phone: e.target.value,
                        });
                      }}
                      renderValue={
                        route?.configured_phone !== ""
                          ? undefined
                          : () => (
                              <span className="text-gray-400">Select...</span>
                            )
                      }
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "0.5rem",
                        height: 48,
                      }}
                    >
                      {incomming_phonenumbers &&
                        incomming_phonenumbers.map((item, index) => (
                          <MenuItem value={item.phoneNumber}>
                            {formatPhoneNumber(item.phoneNumber)}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="border border-gray-200 rounded-xl p-6 bg-white w-[740px] ">
                <div className=" flex items-center justify-between ">
                  {/* Left Section: Icon + Text */}
                  <div className="flex items-start space-x-3">
                    <AccessTime className="text-orange-500 mt-0.5" />
                    <div>
                      <h2 className="text-lg font-semibold text-gray-900">
                        Business Hours
                      </h2>
                      <p className="text-sm text-gray-600">
                        Separate daytime and after-hours call handling
                      </p>
                    </div>
                  </div>

                  {/* Right Section: Disabled Pill */}
                  <div
                    onClick={() => {
                      setEnableBusinessHours(!enableBusinessHours);
                    }}
                    className={
                      enableBusinessHours
                        ? " bg-orange-100 font-bold text-orange-700 text-sm  py-1.5 px-4 rounded-lg cursor-pointer"
                        : "bg-gray-100 text-gray-700 text-sm font-medium py-1.5 px-4 rounded-lg cursor-pointer"
                    }
                  >
                    {enableBusinessHours ? "Enabled" : "Disabled"}
                  </div>
                </div>

                {planDetails?.timeRulesEnabled ? (
                  <>
                    {enableBusinessHours && (
                      <div className=" py-5 bg-white ">
                        <div className="text-[16px] font-medium text-gray-800 mb-4">
                          Weekly Schedule
                        </div>

                        {/* Days List */}
                        <div className="divide-y divide-gray-100 border border-gray-100 rounded-xl overflow-hidden">
                          {days.map(({ key, label }) => {
                            const isActive = route?.[`active_${key}`];
                            const startTime = convertTo24Hour(
                              route?.[`${key}_early_time`] || "09:00"
                            );
                            const endTime = convertTo24Hour(
                              route?.[`${key}_late_time`] || "17:00"
                            );

                            return (
                              <div
                                key={key}
                                className="flex items-center justify-between px-4 py-3"
                              >
                                {/* Day Label */}
                                <div className="w-[60px] text-gray-800 text-sm">
                                  {label}
                                </div>

                                {/* Status Badge */}
                                <div>
                                  {isActive ? (
                                    <span
                                      className="px-2 py-0.5 rounded-md bg-green-50 text-green-700 text-xs border border-green-200 cursor-pointer"
                                      onClick={() => {
                                        handleToggle(key, false);
                                      }}
                                    >
                                      Open
                                    </span>
                                  ) : (
                                    <span
                                      className="px-2 py-0.5 rounded-md bg-gray-100 text-gray-600 text-xs border border-gray-200 cursor-pointer"
                                      onClick={() => {
                                        handleToggle(key, true);
                                      }}
                                    >
                                      Closed
                                    </span>
                                  )}
                                </div>

                                {/* Start Time */}
                                <div className="flex items-center gap-1 w-[120px]">
                                  <AccessTime
                                    sx={{ fontSize: 18, color: "#6B7280" }}
                                  />
                                  <TimePicker
                                    className="custom-time-picker"
                                    disableClock={true}
                                    clearIcon={null}
                                    onChange={(value) =>
                                      handleTimeChange2(key, "early", value)
                                    }
                                    value={startTime}
                                    disabled={!isActive}
                                  />
                                </div>

                                <div className="text-sm text-gray-500">to</div>

                                {/* End Time */}
                                <div className="flex items-center gap-1 w-[120px]">
                                  <TimePicker
                                    className="custom-time-picker"
                                    disableClock={true}
                                    clearIcon={null}
                                    onChange={(value) =>
                                      handleTimeChange2(key, "late", value)
                                    }
                                    value={endTime}
                                    disabled={!isActive}
                                  />
                                  <AccessTime
                                    sx={{ fontSize: 18, color: "#6B7280" }}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {/* Quick Apply Buttons */}
                        <div className="mt-4 flex items-center gap-2 text-sm">
                          <span className="text-gray-600">Quick apply:</span>
                          <button
                            className="px-3 py-1 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50"
                            onClick={() => {
                              const updatedRoute = { ...route };
                              [
                                "monday",
                                "tuesday",
                                "wednesday",
                                "thursday",
                                "friday",
                              ].forEach((day) => {
                                updatedRoute[`active_${day}`] = true;
                                updatedRoute[`${day}_early_time`] = "09:00";
                                updatedRoute[`${day}_late_time`] = "17:00";
                              });
                              ["saturday", "sunday"].forEach((day) => {
                                updatedRoute[`active_${day}`] = false;
                              });
                              setRoute(updatedRoute);
                            }}
                          >
                            Mon–Fri 9:00–17:00
                          </button>
                          <button
                            className="px-3 py-1 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50"
                            onClick={() => {
                              const updatedRoute = { ...route };

                              ["saturday", "sunday"].forEach((day) => {
                                updatedRoute[`active_${day}`] = false;
                              });
                              setRoute(updatedRoute);
                            }}
                          >
                            Weekend Closed
                          </button>
                          <button
                            className="px-3 py-1 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50"
                            onClick={() => {
                              const updatedRoute = { ...route };
                              [
                                "monday",
                                "tuesday",
                                "wednesday",
                                "thursday",
                                "friday",
                              ].forEach((day) => {
                                updatedRoute[`active_${day}`] = true;
                                updatedRoute[`${day}_early_time`] = "09:00";
                                updatedRoute[`${day}_late_time`] = "17:00";
                              });
                              ["saturday", "sunday"].forEach((day) => {
                                updatedRoute[`active_${day}`] = true;
                              });
                              setRoute(updatedRoute);
                            }}
                          >
                            Clear All
                          </button>
                        </div>

                        {/* Timezone Info */}
                        <div className="mt-4 flex justify-end">
                          <div className="text-sm text-gray-500 border border-gray-200 rounded-md px-3 py-1 bg-gray-50">
                            <span className="text-gray-400">Timezone</span>{" "}
                            {
                              JSON.parse(localStorage.getItem("organization"))
                                .org_timezone.S
                            }
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="border-[1px] rounded-[14px] px-2 py-2 w-fit border-[#DADADA] space-y-3 h-[190px] pt-5 relative bottom-2">
                    <div className="text-center lg:text-[14px] text-[12px]">
                      Day/Time Rules
                    </div>
                    <div className="text-center text-[12px]">
                      Please upgrade to edit day/time rules
                    </div>

                    <div className=" pt-[50px]">
                      <Button
                        variant="contained"
                          color="primary"
                          sx={{
                          py: "1px",
                          px: "2px",
                          borderRadius: "7px",
                          fontSize: { lg: "14px", xs: "13px" },
                          width: "100%",
                        }}
                        onClick={() => {
                          handleNavigation("/dashboard/settings/billing");
                        }}
                      >
                        Upgrade
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              <div className=" w-[740px]">
                <div className="text-lg font-semibold text-gray-900 mb-2">
                  Call Action
                </div>

                <ConfigureSlotModal
                  open={openConfigureSlotModal}
                  onClose={setOpenConfigureSlotModal}
                  slot={setSlot}
                  route={route}
                />

                {!slot && (
                  <div className="bg-white rounded-lg border border-gray-200 py-8 px-4 shadow-sm">
                    <div
                      className="border-2 border-dashed border-gray-300 rounded-lg cursor-pointer 
                     flex items-center justify-center h-16 hover:border-gray-400 transition"
                      onClick={() => setOpenConfigureSlotModal(true)}
                    >
                      <Add className="text-gray-500 mr-2" />
                      <span className="text-gray-600">Add Call Action</span>
                    </div>
                  </div>
                )}

                {slot == "ivr" && (
                  <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
                    {/* Header */}
                    <div className="flex justify-between items-start">
                      <div>
                        <div className="flex items-center space-x-2 text-lg font-semibold text-gray-900">
                          <Settings2 className="h-6 w-6 text-indigo-500" />
                          <span>Call Menu (IVR)</span>
                        </div>
                        <p className="text-sm text-gray-500">
                          Let callers choose with keypad
                        </p>
                      </div>
                      <button
                        className="text-sm text-blue-600 font-medium hover:underline"
                        onClick={() => setOpenConfigureSlotModal(true)}
                      >
                        ↻ Change
                      </button>
                    </div>

                    {/* Menu Recording */}
                    <div className="space-y-1">
                      <div className="flex items-center text-sm font-medium text-gray-700">
                        Menu Recording
                        <InfoOutlined
                          className="text-gray-400 ml-1"
                          fontSize="small"
                        />
                      </div>
                      <select
                        onChange={(e) => {
                          setSelectedRecordingTemplate(e.target.value);
                        }}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        <option>Select a recording</option>
                        <option value={"welcome_message"}>
                          Welcome Message (0:15)
                        </option>
                      </select>

                      {selectedRecordingTemplate && (
                        <AudioPlayerForRouting src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3" />
                      )}
                    </div>

                    {/* Menu Options */}
                    <div className="space-y-2">
                      <div className="flex items-center justify-between text-sm font-medium text-gray-700">
                        <div className="flex items-center">
                          Menu Options
                          <InfoOutlined
                            className="text-gray-400 ml-1"
                            fontSize="small"
                          />
                        </div>
                        <button
                          className="text-purple-600 hover:underline text-sm font-medium flex items-center"
                          onClick={() => {
                            setOptions([
                              ...options_,
                              {
                                id: "press_" + (options_.length + 1),
                                name: "Press " + (options_.length + 1),
                                call_action: null,
                                notification: null,
                              },
                            ]);
                          }}
                        >
                          + Add Option
                        </button>
                      </div>

                      {/* Press 1 Option Card */}
                      {options_ &&
                        options_.map((item, index) => (
                          <div className="border rounded-lg p-4 bg-white relative">
                            <button className="absolute top-2 right-2 text-gray-400 hover:text-gray-600">
                              <Close
                                fontSize="small"
                                onClick={() => {
                                  handleCloseCallActionOptions(item);
                                }}
                              />
                            </button>

                            <div className="flex items-center space-x-2 mb-4">
                              <div className="w-6 h-6 rounded-full bg-purple-100 text-purple-600 text-xs font-medium flex items-center justify-center">
                                {index + 1}
                              </div>
                              <span className="text-sm font-semibold text-gray-900">
                                {item.name}
                              </span>
                            </div>

                            {/* Call Action */}
                            <div className="bg-gray-50 border border-gray-100 rounded-lg p-3 mb-2">
                              <div className="flex justify-between items-center">
                                <div>
                                  <div className="text-sm font-medium text-gray-700">
                                    Call Action
                                  </div>
                                  {!callAction && (
                                    <div className="text-sm text-gray-500">
                                      No action configured
                                    </div>
                                  )}
                                </div>

                                <button
                                  className="text-sm font-medium text-purple-600 hover:underline"
                                  onClick={() => {
                                    setOpenConfigureCallActionModal(true);
                                  }}
                                >
                                  {!callAction ? "Add" : "change"}
                                </button>

                                <ConfigureCallActionModal
                                  open={openConfigureCallActionModal}
                                  onClose={setOpenConfigureCallActionModal}
                                  route={route}
                                  callAction={setCallAction}
                                />
                              </div>

                              {callAction && (
                                <div className=" py-5  mt-4 w-full px-2">
                                  <div className="flex items-center space-x-1">
                                    <AccessTime
                                      className="text-orange-500 mt-0.5"
                                      sx={{
                                        fontSize: "18px",
                                        position: "relative",
                                        bottom: "1px",
                                      }}
                                    />
                                    <div>
                                      <h2 className="text-sm text-gray-900">
                                        Business Hours
                                      </h2>
                                    </div>
                                  </div>
                                  <p className="text-[13px] mt-2 text-gray-600">
                                    Route differently during call hours
                                  </p>

                                  <Divider />
                                  <div className="text-[14px] font-medium text-gray-800 mb-4 mt-2">
                                    Weekly Schedule
                                  </div>

                                  {/* Days List */}
                                  <div className="divide-y divide-gray-300 border border-gray-100 rounded-xl overflow-hidden">
                                    {days.map(({ key, label }) => {
                                      const isActive = route?.[`active_${key}`];
                                      const startTime = convertTo24Hour(
                                        route?.[`${key}_early_time`] || "09:00"
                                      );
                                      const endTime = convertTo24Hour(
                                        route?.[`${key}_late_time`] || "17:00"
                                      );

                                      return (
                                        <div
                                          key={key}
                                          className="flex items-center justify-between px-4 py-3"
                                        >
                                          {/* Day Label */}
                                          <div className="w-[60px] text-gray-800 text-sm">
                                            {label}
                                          </div>

                                          {/* Status Badge */}
                                          <div>
                                            {isActive ? (
                                              <span
                                                className="px-2 py-0.5 rounded-md bg-green-50 text-green-700 text-xs border border-green-200 cursor-pointer"
                                                onClick={() => {
                                                  handleToggle(key, false);
                                                }}
                                              >
                                                Open
                                              </span>
                                            ) : (
                                              <span
                                                className="px-2 py-0.5 rounded-md bg-gray-100 text-gray-600 text-xs border border-gray-200 cursor-pointer"
                                                onClick={() => {
                                                  handleToggle(key, true);
                                                }}
                                              >
                                                Closed
                                              </span>
                                            )}
                                          </div>

                                          {/* Start Time */}
                                          <div className="flex items-center gap-1 w-[120px]">
                                            <AccessTime
                                              sx={{
                                                fontSize: 18,
                                                color: "#6B7280",
                                              }}
                                            />
                                            <TimePicker
                                              className="custom-time-picker"
                                              disableClock={true}
                                              clearIcon={null}
                                              onChange={(value) =>
                                                handleTimeChange2(
                                                  key,
                                                  "early",
                                                  value
                                                )
                                              }
                                              value={startTime}
                                              disabled={!isActive}
                                            />
                                          </div>

                                          <div className="text-sm text-gray-500">
                                            to
                                          </div>

                                          {/* End Time */}
                                          <div className="flex items-center gap-1 w-[120px]">
                                            <TimePicker
                                              className="custom-time-picker"
                                              disableClock={true}
                                              clearIcon={null}
                                              onChange={(value) =>
                                                handleTimeChange2(
                                                  key,
                                                  "late",
                                                  value
                                                )
                                              }
                                              value={endTime}
                                              disabled={!isActive}
                                            />
                                            <AccessTime
                                              sx={{
                                                fontSize: 18,
                                                color: "#6B7280",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>

                                  {/* Quick Apply Buttons */}
                                  <span className="text-gray-600 text-[14px] mt-2">
                                    Quick apply:
                                  </span>
                                  <div className="mt-4 flex items-center gap-2 text-sm">
                                    <button
                                      className="text-[13px] px-1 py-1 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50"
                                      onClick={() => {
                                        const updatedRoute = { ...route };
                                        [
                                          "monday",
                                          "tuesday",
                                          "wednesday",
                                          "thursday",
                                          "friday",
                                        ].forEach((day) => {
                                          updatedRoute[`active_${day}`] = true;
                                          updatedRoute[`${day}_early_time`] =
                                            "09:00";
                                          updatedRoute[`${day}_late_time`] =
                                            "17:00";
                                        });
                                        ["saturday", "sunday"].forEach(
                                          (day) => {
                                            updatedRoute[
                                              `active_${day}`
                                            ] = false;
                                          }
                                        );
                                        setRoute(updatedRoute);
                                      }}
                                    >
                                      Mon–Fri 9:00–17:00
                                    </button>
                                    <button
                                      className="px-1 text-[13px] py-1 border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50"
                                      onClick={() => {
                                        const updatedRoute = { ...route };

                                        ["saturday", "sunday"].forEach(
                                          (day) => {
                                            updatedRoute[
                                              `active_${day}`
                                            ] = false;
                                          }
                                        );
                                        setRoute(updatedRoute);
                                      }}
                                    >
                                      Weekend Closed
                                    </button>
                                    <button
                                      className="px-1 py-1 text-[13px] border border-gray-200 rounded-md text-gray-700 hover:bg-gray-50"
                                      onClick={() => {
                                        const updatedRoute = { ...route };
                                        [
                                          "monday",
                                          "tuesday",
                                          "wednesday",
                                          "thursday",
                                          "friday",
                                        ].forEach((day) => {
                                          updatedRoute[`active_${day}`] = true;
                                          updatedRoute[`${day}_early_time`] =
                                            "09:00";
                                          updatedRoute[`${day}_late_time`] =
                                            "17:00";
                                        });
                                        ["saturday", "sunday"].forEach(
                                          (day) => {
                                            updatedRoute[
                                              `active_${day}`
                                            ] = true;
                                          }
                                        );
                                        setRoute(updatedRoute);
                                      }}
                                    >
                                      Clear All
                                    </button>
                                  </div>

                                  {/* Timezone Info */}
                                  <div className="mt-4 flex justify-end">
                                    <div className="text-sm text-gray-500 border border-gray-200 rounded-md px-3 py-1 bg-gray-50">
                                      <span className="text-gray-400">
                                        Timezone
                                      </span>{" "}
                                      {
                                        JSON.parse(
                                          localStorage.getItem("organization")
                                        ).org_timezone.S
                                      }
                                    </div>
                                  </div>

                                  <div className="flex items-start space-x-4 w-full mt-4">
                                    <div className="w-full">
                                      <div className="text-[13px] font-semibold text-gray-500">
                                        DURING BUSINESS HOURS
                                      </div>
                                      <div className="bg-white rounded-lg border border-gray-200 py-4 px-2 shadow-sm w-full">
                                        {!businessHourCallActionChoice && (
                                          <div
                                            className="border-2 border-dashed border-gray-300 rounded-lg cursor-pointer 
     flex items-center justify-center h-16 hover:border-gray-400 transition text-[13px]"
                                            onClick={() =>
                                              setOpenConfigureCallActionForBusinessHoursModal(
                                                true
                                              )
                                            }
                                          >
                                            <Add className="text-gray-500  mr-2" />
                                            <span className="text-gray-600">
                                              Add Call Action
                                            </span>
                                          </div>
                                        )}

                                        {businessHourCallActionChoice ==
                                          "forward" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Forward Call
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                                                onClick={() =>
                                                  setOpenConfigureCallActionForBusinessHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Destination
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a destination
                                                </option>
                                                <option value="number">
                                                  Phone Number
                                                </option>
                                                <option value="voicemail">
                                                  Voicemail
                                                </option>
                                                <option value="menu">
                                                  IVR Menu
                                                </option>
                                              </select>
                                            </div>

                                            {/* Caller ID Setting */}
                                            <div>
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Caller ID Setting
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue="original"
                                              >
                                                <option value="original">
                                                  Show Original Caller’s Number
                                                </option>
                                                <option value="system">
                                                  Show System Number
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {businessHourCallActionChoice ==
                                          "ring_browser" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center  gap-1">
                                                <HeadsetMic className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Ring User or Group in Browser
                                                </h2>
                                              </div>
                                              <button
                                                className=" text-blue-600 font-medium hover:underline text-[13px]"
                                                onClick={() =>
                                                  setOpenConfigureCallActionForBusinessHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            <div className="text-[13px] text-gray-400 italic">
                                              Configuration options for "Ring
                                              User or Group in Browser" will be
                                              available here.
                                            </div>
                                          </div>
                                        )}

                                        {businessHourCallActionChoice ==
                                          "forwardvwm" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Forward Call w/VM
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                                                onClick={() =>
                                                  setOpenConfigureCallActionForBusinessHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Destination
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a destination
                                                </option>
                                                <option value="number">
                                                  Phone Number
                                                </option>
                                                <option value="voicemail">
                                                  Voicemail
                                                </option>
                                                <option value="menu">
                                                  IVR Menu
                                                </option>
                                              </select>
                                            </div>

                                            {/* Caller ID Setting */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Caller ID Setting
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue="original"
                                              >
                                                <option value="original">
                                                  Show Original Caller’s Number
                                                </option>
                                                <option value="system">
                                                  Show System Number
                                                </option>
                                              </select>
                                            </div>

                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Call Approval
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue="original"
                                              >
                                                <option value="original">
                                                  Disabled - Connect Immediately
                                                </option>
                                                <option value="system">
                                                  Show System Number
                                                </option>
                                              </select>
                                            </div>

                                            <div>
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Recording
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue="original"
                                              >
                                                <option value="original">
                                                  Select a recording
                                                </option>
                                                <option value="system">
                                                  Welcome message (0:15)
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {businessHourCallActionChoice ==
                                          "send_to_vm" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Send to a Voicemail
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                                                onClick={() =>
                                                  setOpenConfigureCallActionForBusinessHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Recording
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a recording
                                                </option>
                                                <option value="number">
                                                  Welcome message (0:15)
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        <ConfigureCallActionForBusinessModal
                                          open={
                                            openConfigureCallActionForBusinessHoursModal
                                          }
                                          onClose={
                                            setOpenConfigureCallActionForBusinessHoursModal
                                          }
                                          route={route}
                                          callAction={
                                            setBusinessHourCallActionChoice
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="w-full">
                                      <div className="text-[13px] font-semibold text-gray-500">
                                        AFTER HOURS
                                      </div>
                                      <div className="bg-white rounded-lg border border-gray-200 py-4 px-2 shadow-sm w-full">
                                        {!AfterHourCallActionChoice && (
                                          <div
                                            className="border-2 border-dashed border-gray-300 rounded-lg cursor-pointer 
     flex items-center justify-center h-16 hover:border-gray-400 transition text-[13px]"
                                            onClick={() =>
                                              setOpenConfigureCallActionForAfterHoursModal(
                                                true
                                              )
                                            }
                                          >
                                            <Add className="text-gray-500  mr-2" />
                                            <span className="text-gray-600">
                                              Add Call Action
                                            </span>
                                          </div>
                                        )}

                                        {AfterHourCallActionChoice ==
                                          "forward" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Forward Call
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                                                onClick={() =>
                                                  setOpenConfigureCallActionForAfterHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Destination
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a destination
                                                </option>
                                                <option value="number">
                                                  Phone Number
                                                </option>
                                                <option value="voicemail">
                                                  Voicemail
                                                </option>
                                                <option value="menu">
                                                  IVR Menu
                                                </option>
                                              </select>
                                            </div>

                                            {/* Caller ID Setting */}
                                            <div>
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Caller ID Setting
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue="original"
                                              >
                                                <option value="original">
                                                  Show Original Caller’s Number
                                                </option>
                                                <option value="system">
                                                  Show System Number
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {AfterHourCallActionChoice ==
                                          "ring_browser" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center  gap-1">
                                                <HeadsetMic className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Ring User or Group in Browser
                                                </h2>
                                              </div>
                                              <button
                                                className=" text-blue-600 font-medium hover:underline text-[13px]"
                                                onClick={() =>
                                                  setOpenConfigureCallActionForAfterHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            <div className="text-[13px] text-gray-400 italic">
                                              Configuration options for "Ring
                                              User or Group in Browser" will be
                                              available here.
                                            </div>
                                          </div>
                                        )}

                                        {AfterHourCallActionChoice ==
                                          "forwardvwm" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Forward Call w/VM
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                                                onClick={() =>
                                                  setOpenConfigureCallActionForAfterHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Destination
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a destination
                                                </option>
                                                <option value="number">
                                                  Phone Number
                                                </option>
                                                <option value="voicemail">
                                                  Voicemail
                                                </option>
                                                <option value="menu">
                                                  IVR Menu
                                                </option>
                                              </select>
                                            </div>

                                            {/* Caller ID Setting */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Caller ID Setting
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue="original"
                                              >
                                                <option value="original">
                                                  Show Original Caller’s Number
                                                </option>
                                                <option value="system">
                                                  Show System Number
                                                </option>
                                              </select>
                                            </div>

                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Call Approval
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue="original"
                                              >
                                                <option value="original">
                                                  Disabled - Connect Immediately
                                                </option>
                                                <option value="system">
                                                  Show System Number
                                                </option>
                                              </select>
                                            </div>

                                            <div>
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Recording
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue="original"
                                              >
                                                <option value="original">
                                                  Select a recording
                                                </option>
                                                <option value="system">
                                                  Welcome message (0:15)
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {AfterHourCallActionChoice ==
                                          "send_to_vm" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Send to a Voicemail
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                                                onClick={() =>
                                                  setOpenConfigureNotificationForAfterHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Recording
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a recording
                                                </option>
                                                <option value="number">
                                                  Welcome message (0:15)
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        <ConfigureCallActionForAfterModal
                                          open={
                                            openConfigureNotificationForAfterHoursModal
                                          }
                                          onClose={
                                            setOpenConfigureNotificationForAfterHoursModal
                                          }
                                          route={route}
                                          callAction={
                                            setAfterHourNotificationChoice
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-[14px] font-bold mt-4">
                                    {" "}
                                    Notifications{" "}
                                  </div>
                                  <div className="flex items-start space-x-4 w-full mt-4">
                                    <div className="w-full">
                                      <div className="text-[13px] font-semibold text-gray-500">
                                        DURING BUSINESS HOURS
                                      </div>
                                      <div className="bg-white rounded-lg border border-gray-200 py-4 px-2 shadow-sm w-full">
                                        {!businessHourNotificationChoice && (
                                          <div
                                            className="border-2 border-dashed border-gray-300 rounded-lg cursor-pointer 
     flex items-center justify-center h-16 hover:border-gray-400 transition text-[13px]"
                                            onClick={() =>
                                              setOpenConfigureNotificationForBusinessHoursModal(
                                                true
                                              )
                                            }
                                          >
                                            <Add className="text-gray-500  mr-2" />
                                            <span className="text-gray-600">
                                              Add Notification
                                            </span>
                                          </div>
                                        )}

                                        {businessHourNotificationChoice ==
                                          "email" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Email Notification
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                                onClick={() =>
                                                  setOpenConfigureNotificationForBusinessHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                              <button
                                                className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                                onClick={() =>
                                                  setBusinessHourNotificationChoice(
                                                    null
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Channel
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a channel
                                                </option>
                                                <option value="number">
                                                  Alerts Channel
                                                </option>
                                                <option value="voicemail">
                                                  Support Channel
                                                </option>
                                                <option value="menu">
                                                  Sales Channel
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {businessHourNotificationChoice ==
                                          "slack" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Slack Notification
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                                onClick={() =>
                                                  setOpenConfigureNotificationForBusinessHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                              <button
                                                className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                                onClick={() =>
                                                  setBusinessHourNotificationChoice(
                                                    null
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Channel
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a channel
                                                </option>
                                                <option value="number">
                                                  Alerts Channel
                                                </option>
                                                <option value="voicemail">
                                                  Support Channel
                                                </option>
                                                <option value="menu">
                                                  Sales Channel
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {businessHourNotificationChoice ==
                                          "sms" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  SMS Notification
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                                onClick={() =>
                                                  setOpenConfigureNotificationForBusinessHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                              <button
                                                className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                                onClick={() =>
                                                  setBusinessHourNotificationChoice(
                                                    null
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Channel
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a channel
                                                </option>
                                                <option value="number">
                                                  Alerts Channel
                                                </option>
                                                <option value="voicemail">
                                                  Support Channel
                                                </option>
                                                <option value="menu">
                                                  Sales Channel
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {businessHourNotificationChoice ==
                                          "front" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Front Notification
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                                onClick={() =>
                                                  setOpenConfigureNotificationForBusinessHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                              <button
                                                className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                                onClick={() =>
                                                  setBusinessHourNotificationChoice(
                                                    null
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Channel
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a channel
                                                </option>
                                                <option value="number">
                                                  Alerts Channel
                                                </option>
                                                <option value="voicemail">
                                                  Support Channel
                                                </option>
                                                <option value="menu">
                                                  Sales Channel
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        <ConfigureNotificationForBusinessHours
                                          open={
                                            openConfigureNotificationForBusinessHoursModal
                                          }
                                          onClose={
                                            setOpenConfigureNotificationForBusinessHoursModal
                                          }
                                          callAction={
                                            setBusinessHourNotificationChoice
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="w-full">
                                      <div className="text-[13px] font-semibold text-gray-500">
                                        AFTER HOURS
                                      </div>
                                      <div className="bg-white rounded-lg border border-gray-200 py-4 px-2 shadow-sm w-full">
                                        {!AfterHourNotificationChoice && (
                                          <div
                                            className="border-2 border-dashed border-gray-300 rounded-lg cursor-pointer 
     flex items-center justify-center h-16 hover:border-gray-400 transition text-[13px]"
                                            onClick={() =>
                                              setOpenConfigureNotificationForAfterHoursModal(
                                                true
                                              )
                                            }
                                          >
                                            <Add className="text-gray-500  mr-2" />
                                            <span className="text-gray-600">
                                              Add Notification
                                            </span>
                                          </div>
                                        )}

                                        {AfterHourNotificationChoice ==
                                          "email" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Email Notification
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                                onClick={() =>
                                                  setOpenConfigureNotificationForAfterHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                              <button
                                                className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                                onClick={() =>
                                                  setAfterHourNotificationChoice(
                                                    null
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Channel
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a channel
                                                </option>
                                                <option value="number">
                                                  Alerts Channel
                                                </option>
                                                <option value="voicemail">
                                                  Support Channel
                                                </option>
                                                <option value="menu">
                                                  Sales Channel
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {AfterHourNotificationChoice ==
                                          "slack" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Slack Notification
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                                onClick={() =>
                                                  setOpenConfigureNotificationForAfterHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                              <button
                                                className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                                onClick={() =>
                                                  setAfterHourNotificationChoice(
                                                    null
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Channel
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a channel
                                                </option>
                                                <option value="number">
                                                  Alerts Channel
                                                </option>
                                                <option value="voicemail">
                                                  Support Channel
                                                </option>
                                                <option value="menu">
                                                  Sales Channel
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {AfterHourNotificationChoice ==
                                          "sms" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  SMS Notification
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                                onClick={() =>
                                                  setOpenConfigureNotificationForAfterHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                              <button
                                                className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                                onClick={() =>
                                                  setAfterHourNotificationChoice(
                                                    null
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Channel
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a channel
                                                </option>
                                                <option value="number">
                                                  Alerts Channel
                                                </option>
                                                <option value="voicemail">
                                                  Support Channel
                                                </option>
                                                <option value="menu">
                                                  Sales Channel
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        {AfterHourNotificationChoice ==
                                          "front" && (
                                          <div className="">
                                            {/* Header */}
                                            <div className="flex items-center justify-between mb-3">
                                              <div className="flex items-center ">
                                                <KeyboardArrowRight className="text-green-500" />
                                                <h2 className="font-medium text-[13px] text-gray-800">
                                                  Front Notification
                                                </h2>
                                              </div>
                                              <button
                                                className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                                onClick={() =>
                                                  setOpenConfigureNotificationForAfterHoursModal(
                                                    true
                                                  )
                                                }
                                              >
                                                Change
                                              </button>
                                              <button
                                                className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                                onClick={() =>
                                                  setAfterHourNotificationChoice(
                                                    null
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </div>

                                            <hr className="border-gray-200 mb-4" />

                                            {/* Destination */}
                                            <div className="mb-4">
                                              <div className="flex items-center gap-1 mb-1">
                                                <span className="text-sm font-medium text-gray-700">
                                                  Channel
                                                </span>
                                                <Info
                                                  className="text-gray-400"
                                                  fontSize="small"
                                                />
                                              </div>
                                              <select
                                                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                defaultValue=""
                                              >
                                                <option value="" disabled>
                                                  Select a channel
                                                </option>
                                                <option value="number">
                                                  Alerts Channel
                                                </option>
                                                <option value="voicemail">
                                                  Support Channel
                                                </option>
                                                <option value="menu">
                                                  Sales Channel
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        )}

                                        <ConfigureNotificationForAfterHours
                                          open={
                                            openConfigureNotificationForAfterHoursModal
                                          }
                                          onClose={
                                            setOpenConfigureNotificationForAfterHoursModal
                                          }
                                          callAction={
                                            setAfterHourNotificationChoice
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Notification */}

                            {callAction != "ivr" && (
                              <>
                                {!businessHourNotificationChoice && (
                                  <div className="bg-gray-50 border border-gray-100 rounded-lg p-3">
                                    <div className="flex justify-between items-center">
                                      <div>
                                        <div className="text-sm font-medium text-gray-700">
                                          Notification 
                                        </div>

                                        <div className="text-sm text-gray-500">
                                          No notification configured
                                        </div>
                                      </div>
                                      <button
                                        className="text-sm font-medium text-purple-600 hover:underline"
                                        onClick={() =>
                                          setOpenConfigureNotificationForBusinessHoursModal(
                                            true
                                          )
                                        }
                                      >
                                        Add
                                      </button>
                                    </div>
                                  </div>
                                )}

                                <div className="w-full">
                                  <div className="bg-white rounded-lg border border-gray-200 py-4 px-2 shadow-sm w-full">
                                    {businessHourNotificationChoice ==
                                      "email" && (
                                      <div className="">
                                        {/* Header */}
                                        <div className="flex items-center justify-between mb-3">
                                          <div className="flex items-center ">
                                            <KeyboardArrowRight className="text-green-500" />
                                            <h2 className="font-medium text-[13px] text-gray-800">
                                              Email Notification
                                            </h2>
                                          </div>
                                          <div className="flex items-center space-x-4">
                                            <button
                                              className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                              onClick={() =>
                                                setOpenConfigureNotificationForBusinessHoursModal(
                                                  true
                                                )
                                              }
                                            >
                                              Change
                                            </button>
                                            <button
                                              className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                              onClick={() =>
                                                setBusinessHourNotificationChoice(
                                                  null
                                                )
                                              }
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        </div>

                                        <hr className="border-gray-200 mb-4" />

                                        {/* Destination */}
                                        <div className="mb-4">
                                          <div className="flex items-center gap-1 mb-1">
                                            <span className="text-sm font-medium text-gray-700">
                                              Channel
                                            </span>
                                            <Info
                                              className="text-gray-400"
                                              fontSize="small"
                                            />
                                          </div>
                                          <select
                                            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            defaultValue=""
                                          >
                                            <option value="" disabled>
                                              Select a channel
                                            </option>
                                            <option value="number">
                                              Alerts Channel
                                            </option>
                                            <option value="voicemail">
                                              Support Channel
                                            </option>
                                            <option value="menu">
                                              Sales Channel
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}

                                    {businessHourNotificationChoice ==
                                      "slack" && (
                                      <div className="">
                                        {/* Header */}
                                        <div className="flex items-center justify-between mb-3">
                                          <div className="flex items-center ">
                                            <KeyboardArrowRight className="text-green-500" />
                                            <h2 className="font-medium text-[13px] text-gray-800">
                                              Slack Notification
                                            </h2>
                                          </div>
                                          <button
                                            className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                            onClick={() =>
                                              setOpenConfigureNotificationForBusinessHoursModal(
                                                true
                                              )
                                            }
                                          >
                                            Change
                                          </button>
                                          <button
                                            className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                            onClick={() =>
                                              setBusinessHourNotificationChoice(
                                                null
                                              )
                                            }
                                          >
                                            Remove
                                          </button>
                                        </div>

                                        <hr className="border-gray-200 mb-4" />

                                        {/* Destination */}
                                        <div className="mb-4">
                                          <div className="flex items-center gap-1 mb-1">
                                            <span className="text-sm font-medium text-gray-700">
                                              Channel
                                            </span>
                                            <Info
                                              className="text-gray-400"
                                              fontSize="small"
                                            />
                                          </div>
                                          <select
                                            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            defaultValue=""
                                          >
                                            <option value="" disabled>
                                              Select a channel
                                            </option>
                                            <option value="number">
                                              Alerts Channel
                                            </option>
                                            <option value="voicemail">
                                              Support Channel
                                            </option>
                                            <option value="menu">
                                              Sales Channel
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}

                                    {businessHourNotificationChoice ==
                                      "sms" && (
                                      <div className="">
                                        {/* Header */}
                                        <div className="flex items-center justify-between mb-3">
                                          <div className="flex items-center ">
                                            <KeyboardArrowRight className="text-green-500" />
                                            <h2 className="font-medium text-[13px] text-gray-800">
                                              SMS Notification
                                            </h2>
                                          </div>
                                          <button
                                            className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                            onClick={() =>
                                              setOpenConfigureNotificationForBusinessHoursModal(
                                                true
                                              )
                                            }
                                          >
                                            Change
                                          </button>
                                          <button
                                            className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                            onClick={() =>
                                              setBusinessHourNotificationChoice(
                                                null
                                              )
                                            }
                                          >
                                            Remove
                                          </button>
                                        </div>

                                        <hr className="border-gray-200 mb-4" />

                                        {/* Destination */}
                                        <div className="mb-4">
                                          <div className="flex items-center gap-1 mb-1">
                                            <span className="text-sm font-medium text-gray-700">
                                              Channel
                                            </span>
                                            <Info
                                              className="text-gray-400"
                                              fontSize="small"
                                            />
                                          </div>
                                          <select
                                            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            defaultValue=""
                                          >
                                            <option value="" disabled>
                                              Select a channel
                                            </option>
                                            <option value="number">
                                              Alerts Channel
                                            </option>
                                            <option value="voicemail">
                                              Support Channel
                                            </option>
                                            <option value="menu">
                                              Sales Channel
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}

                                    {businessHourNotificationChoice ==
                                      "front" && (
                                      <div className="">
                                        {/* Header */}
                                        <div className="flex items-center justify-between mb-3">
                                          <div className="flex items-center ">
                                            <KeyboardArrowRight className="text-green-500" />
                                            <h2 className="font-medium text-[13px] text-gray-800">
                                              Front Notification
                                            </h2>
                                          </div>
                                          <button
                                            className="text-sm text-blue-600 font-medium hover:underline text-[13px] mr-2"
                                            onClick={() =>
                                              setOpenConfigureNotificationForBusinessHoursModal(
                                                true
                                              )
                                            }
                                          >
                                            Change
                                          </button>
                                          <button
                                            className="text-sm text-red-600 font-medium hover:underline text-[13px] "
                                            onClick={() =>
                                              setBusinessHourNotificationChoice(
                                                null
                                              )
                                            }
                                          >
                                            Remove
                                          </button>
                                        </div>

                                        <hr className="border-gray-200 mb-4" />

                                        {/* Destination */}
                                        <div className="mb-4">
                                          <div className="flex items-center gap-1 mb-1">
                                            <span className="text-sm font-medium text-gray-700">
                                              Channel
                                            </span>
                                            <Info
                                              className="text-gray-400"
                                              fontSize="small"
                                            />
                                          </div>
                                          <select
                                            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                            defaultValue=""
                                          >
                                            <option value="" disabled>
                                              Select a channel
                                            </option>
                                            <option value="number">
                                              Alerts Channel
                                            </option>
                                            <option value="voicemail">
                                              Support Channel
                                            </option>
                                            <option value="menu">
                                              Sales Channel
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    )}

                                    <ConfigureNotificationForBusinessHours
                                      open={
                                        openConfigureNotificationForBusinessHoursModal
                                      }
                                      onClose={
                                        setOpenConfigureNotificationForBusinessHoursModal
                                      }
                                      callAction={
                                        setBusinessHourNotificationChoice
                                      }
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                )}

                {slot == "forward" && (
                  <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-5">
                      <div className="flex items-center ">
                        <ArrowRight className="text-green-500" />
                        <div>
                          <h2 className="font-bold text-[18px]  text-gray-800">
                            Forward Call
                          </h2>

                          <div className="text-[13px]">
                            Send the call to another number
                          </div>
                        </div>
                      </div>
                      <button
                        className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                        onClick={() => setOpenConfigureSlotModal(true)}
                      >
                        ↻ Change
                      </button>
                    </div>

                    {/* Destination */}
                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Destination
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select a destination
                        </option>
                        <option value="number">Phone Number</option>
                        <option value="voicemail">Voicemail</option>
                        <option value="menu">IVR Menu</option>
                      </select>
                    </div>

                    {/* Caller ID Setting */}
                    <div>
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Caller ID Setting
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue="original"
                      >
                        <option value="original">
                          Show Original Caller’s Number
                        </option>
                        <option value="system">Show System Number</option>
                      </select>
                    </div>
                  </div>
                )}

                {slot == "ring_browser" && (
                  <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center  gap-1">
                        <HeadsetMic className="text-green-500" />
                        <div>
                          <h2 className="font-bold text-[18px]  text-gray-800">
                            Ring User or Group in Browser
                          </h2>

                          <div className="text-[13px]">
                            Ring a configured user or group{" "}
                          </div>
                        </div>
                      </div>
                      <button
                        className=" text-blue-600 font-medium hover:underline text-[13px]"
                        onClick={() => setOpenConfigureSlotModal(true)}
                      >
                        ↻ Change
                      </button>
                    </div>

                    {/* Destination */}
                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Ring Target
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select a ring target
                        </option>
                        <option value="number">Ring group</option>
                      </select>
                    </div>

                    {/* Caller ID Setting */}
                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Ring Group
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue="original"
                      >
                        <option value="original">Select Ring Group</option>
                        <option value="system">Ring Group</option>
                      </select>
                    </div>
                  </div>
                )}

                {slot == "forwardvwm" && (
                  <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center ">
                        <KeyboardArrowRight className="text-green-500" />
                        <div>
                          <h2 className="font-bold text-[18px]  text-gray-800">
                            Forward Call w/VM
                          </h2>

                          <div className="text-[13px]">
                            Forward with voicemail fallback{" "}
                          </div>
                        </div>
                      </div>
                      <button
                        className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                        onClick={() => setOpenConfigureSlotModal(true)}
                      >
                        ↻ Change
                      </button>
                    </div>

                    {/* Destination */}
                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Destination
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select a destination
                        </option>
                        <option value="number">Phone Number</option>
                        <option value="voicemail">Voicemail</option>
                        <option value="menu">IVR Menu</option>
                      </select>
                    </div>

                    {/* Caller ID Setting */}
                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Caller ID Setting
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue="original"
                      >
                        <option value="original">
                          Show Original Caller’s Number
                        </option>
                        <option value="system">Show System Number</option>
                      </select>
                    </div>

                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Call Approval
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue="original"
                      >
                        <option value="original">
                          Disabled - Connect Immediately
                        </option>
                        <option value="system">Show System Number</option>
                      </select>
                    </div>

                    <div>
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Recording
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue="original"
                      >
                        <option value="original">Select a recording</option>
                        <option value="system">Welcome message (0:15)</option>
                      </select>
                    </div>
                  </div>
                )}

                <div className="text-lg font-semibold text-gray-900 mb-2">
                  Notification 
                </div>

                <ConfigureNotificationModal
                  open={openConfigureNotificationMainModal}
                  onClose={setOpenConfigureNotificationMainModal}
                  slot={setNotificationMain}
                />

                {/* Notification */}
                {!notificationMain && (
                  <div className=" w-[740px] mt-5">
                    <div className="bg-white rounded-lg border border-gray-200 py-8 px-4 shadow-sm">
                      <div
                        className="border-2 border-dashed border-gray-300 rounded-lg cursor-pointer 
                     flex items-center justify-center h-16 hover:border-gray-400 transition"
                        onClick={() =>
                          setOpenConfigureNotificationMainModal(true)
                        }
                      >
                        <Add className="text-gray-500 mr-2" />
                        <span className="text-gray-600">Add Notification</span>
                      </div>
                    </div>
                  </div>
                )}
                {notificationMain == "email" && (
                  <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-5">
                      <div className="flex items-center ">
                        <ArrowRight className="text-green-500" />
                        <div>
                          <h2 className="font-bold text-[18px]  text-gray-800">
                            Email Notification
                          </h2>

                          <div className="text-[13px]">Send email alerts</div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                          onClick={() =>
                            setOpenConfigureNotificationMainModal(true)
                          }
                        >
                          ↻ Change
                        </button>

                        <button
                          className="text-sm text-red-600 font-medium hover:underline text-[13px]"
                          onClick={() => setNotificationMain(null)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>

                    {/* Destination */}
                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Channel
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select a channel
                        </option>
                        <option value="number">Support Channel</option>
                      </select>
                    </div>
                  </div>
                )}

                {notificationMain == "slack" && (
                  <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-5">
                      <div className="flex items-center ">
                        <ArrowRight className="text-green-500" />
                        <div>
                          <h2 className="font-bold text-[18px]  text-gray-800">
                            Slack Notification
                          </h2>

                          <div className="text-[13px]">Send Slack messages</div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                          onClick={() =>
                            setOpenConfigureNotificationMainModal(true)
                          }
                        >
                          ↻ Change
                        </button>

                        <button
                          className="text-sm text-red-600 font-medium hover:underline text-[13px]"
                          onClick={() => setNotificationMain(null)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>

                    {/* Destination */}
                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Channel
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select a channel
                        </option>
                        <option value="number">Support Channel</option>
                      </select>
                    </div>
                  </div>
                )}

                {notificationMain == "sms" && (
                  <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-5">
                      <div className="flex items-center ">
                        <ArrowRight className="text-green-500" />
                        <div>
                          <h2 className="font-bold text-[18px]  text-gray-800">
                            SMS Notification
                          </h2>

                          <div className="text-[13px]">Send text Messages</div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                          onClick={() =>
                            setOpenConfigureNotificationMainModal(true)
                          }
                        >
                          ↻ Change
                        </button>

                        <button
                          className="text-sm text-red-600 font-medium hover:underline text-[13px]"
                          onClick={() => setNotificationMain(null)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>

                    {/* Destination */}
                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Channel
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select a channel
                        </option>
                        <option value="number">Support Channel</option>
                      </select>
                    </div>
                  </div>
                )}

                {notificationMain == "front" && (
                  <div className="bg-white border rounded-xl p-6 space-y-4 shadow-sm">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-5">
                      <div className="flex items-center ">
                        <ArrowRight className="text-green-500" />
                        <div>
                          <h2 className="font-bold text-[18px]  text-gray-800">
                            Front Notification
                          </h2>

                          <div className="text-[13px]">
                            Create Front tickets
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <button
                          className="text-sm text-blue-600 font-medium hover:underline text-[13px]"
                          onClick={() => setOpenConfigureSlotModal(true)}
                        >
                          ↻ Change
                        </button>

                        <button
                          className="text-sm text-red-600 font-medium hover:underline text-[13px]"
                          onClick={() => setNotificationMain(null)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>

                    {/* Destination */}
                    <div className="mb-4">
                      <div className="flex items-center gap-1 mb-1">
                        <span className="text-sm font-medium text-gray-700">
                          Channel
                        </span>
                        <Info className="text-gray-400" fontSize="small" />
                      </div>
                      <select
                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        defaultValue=""
                      >
                        <option value="" disabled>
                          Select a channel
                        </option>
                        <option value="number">Support Channel</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="">
            <div className="lg:px-8 px-4 py-14 bg-white  w-fit">
              {/* <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">Alert !!</div> */}

              <div className="lg:text-[14px] text-[13px] text-center mb-2">
                Oops! We couldn't find a record for{" "}
                {route_id ? "route" : "call"}{" "}
                <span className="font-bold"> {route_id}</span> in{" "}
                <span className="font-bold">
                  {
                    JSON.parse(localStorage.getItem("organization"))
                      ?.organization_name?.S
                  }
                </span>
                . Is it possible the URL is incorrect or that you mean to be
                logged in as a different organization? If you need help, please{" "}
                <a
                  className="text-blue-800 hover:underline"
                  href="mailto:hello@twilanswer.com"
                >
                  Contact Support
                </a>
                .
              </div>

              {/* <div>
              <Select
                        IconComponent={KeyboardArrowDown}
                        fullWidth
                        value={
                          user?.relatedOrgs.L.filter(
                            (e) =>
                              e?.M.org_id.S ===
                              JSON.parse(localStorage.getItem("organization")).orgId.S
                          )[0]?.M.org_id.S
                        }
                        onChange={(f) => {
                          changeOrganization(f.target.value);
                        }}
                        className="mb-2 bg-[#F7F7F8]"
                        sx={{
                          fontSize: "13px",
                          padding: "2px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                          "& .MuiSelect-select": {
                            padding: "2px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        {user?.relatedOrgs.L.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.M.org_id.S}>{orgs?.find((e)=> e.orgId.S === item.M.org_id.S)?.organization_name.S}</MenuItem>
                          );
                        })}
                      </Select>
        </div> */}

              <div className="flex items-center justify-center space-x-3 mt-4">
                <div className="flex items-center justify-center space-x-3 mt-4">
                  <Button
                    sx={{
                      textTransform: "none",
                      bgcolor: "rgba(236,72,92,0.1)",
                      color: "rgba(236,72,92,1)",
                      py: "6px",
                      px: "30px",
                      borderRadius: "7px",

                      fontSize: { lg: "14px", xs: "13px" },
                      width: "fit",
                    }}
                    onClick={() => {
                      console.info("[Auth] Logging out: user chose Logout from CallRoute.");
                      localStorage.clear();
                      navigate("/login");
                    }}
                  >
                    Logout
                  </Button>

                  <Button
                    variant="contained"
                      color="primary"
                      sx={{
                      py: "6px",
                      px: "30px",
                      borderRadius: "7px",

                      fontSize: { lg: "14px", xs: "13px" },
                      width: "fit",
                    }}
                    onClick={() => {
                      {
                        route_id
                          ? navigate("/dashboard/call-routings")
                          : navigate("/dashboard/");
                      }
                    }}
                  >
                    Go to {route_id ? "routes" : "dashboard"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      </RouteConfigModalsProvider>
    </>
  );
};

export default CallRoute;

const days = [
  { key: "monday", label: "Mon" },
  { key: "tuesday", label: "Tue" },
  { key: "wednesday", label: "Wed" },
  { key: "thursday", label: "Thu" },
  { key: "friday", label: "Fri" },
  { key: "saturday", label: "Sat" },
  { key: "sunday", label: "Sun" },
];
